import { render, staticRenderFns } from "./GameWhistleSvg.vue?vue&type=template&id=2f261106&"
import script from "./GameWhistleSvg.vue?vue&type=script&lang=ts&"
export * from "./GameWhistleSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports